var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('span', { staticClass: "pt-hightlight-text", domProps: { "innerHTML": _vm._s(_vm.html) } });
};
var staticRenderFns = [];

export { render, staticRenderFns };